import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import './styles/bookingFlow.css';
import App from './App';

// Método nuevo para React 18
const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);